import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../layouts/default";
import { FaUsers } from "react-icons/fa";
import { Button, Spinner, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CreateNewAgentGroup from "./CreateNewAgentGroup";
import DynamicAgentList from "./DynamicAgentList";

import { fetchAllDynamicAgentGroups } from "../../store/slices/smartConnect/dynamicAgentGroup";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

function SmartConnectAgentList() {
  const dispatch = useDispatch();
  const [selectedSetting, setSelectedSetting] = useState({});
  const { dynamicAgentGroups, loading, error } = useSelector(
    (store) => store.dynamicAgentGroupReducer,
  );
  const [groupStatus, setGroupStatus] = useState(true);

  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchGroups = useCallback(() => {
    dispatch(fetchAllDynamicAgentGroups({ page: 1, limit: 10 }));
  }, [dispatch]);

  // Initial fetch
  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  useEffect(() => {
    if (dynamicAgentGroups?.length > 0 && !selectedGroupId) {
      setSelectedGroupId(dynamicAgentGroups[0].id);
      setSelectedSetting(dynamicAgentGroups[0]?.smart_connect_setting);
      setGroupStatus(dynamicAgentGroups[0]?.status === 1 ? true : false);
    }
  }, [dynamicAgentGroups, selectedGroupId]);

  const handleGroupClick = (group) => {
    setSelectedGroupId(group.id);
    setSelectedSetting(group?.smart_connect_setting);
    setGroupStatus(group?.status === 1 ? true : false);
  };

  const handleGroupCreated = (newGroup) => {
    fetchGroups();
    if (newGroup?.id) {
      setSelectedGroupId(newGroup.id);
    }
  };

  if (!hasPermission(PERMISSIONS.SMART_CONNECT.VIEW)) {
    return (
      <div>
        <h3>You do not have permission to view smart connect features.</h3>
      </div>
    );
  }

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaUsers size={22} />
          <h3 style={{ margin: 0 }}>Agent Directory</h3>
        </div>

        {hasPermission(PERMISSIONS.SMART_CONNECT.CREATE) && (
          <Button variant="primary" onClick={() => setShowModal(true)}>
            + Create New Group
          </Button>
        )}
      </div>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      )}

      {error && (
        <Alert variant="danger" className="my-3">
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <>
          {dynamicAgentGroups?.length > 0 && (
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {dynamicAgentGroups.map((group) => (
                <Button
                  key={group.id}
                  variant={
                    selectedGroupId === group.id
                      ? "secondary"
                      : "outline-secondary"
                  }
                  onClick={() => handleGroupClick(group)}
                >
                  {group.group_name}
                </Button>
              ))}
            </div>
          )}

          {dynamicAgentGroups?.length > 0 && selectedGroupId && (
            <DynamicAgentList
              groupId={selectedGroupId}
              groupStatus={groupStatus}
              selectedSetting={selectedSetting}
            />
          )}

          {dynamicAgentGroups?.length === 0 && (
            <div className="text-muted mt-4">
              No dynamic agent groups found.
            </div>
          )}
        </>
      )}

      <CreateNewAgentGroup
        show={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleGroupCreated}
      />
    </Layout>
  );
}

export default SmartConnectAgentList;
